import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import ITenantInfoByCompetenceDate from '../../interfaces/ITenantInfoByCompetenceDate';
import ITenant from '../../interfaces/ITenant';
import IValidationOption from '../../interfaces/IValidationOption';

const useTenantService = () => {
  const request = useRequest<ITenantInfoByCompetenceDate>();
  const tenantRequest = useRequest<ITenant>();
  const validationOptionRequest = useRequest<IValidationOption>();

  const path = 'tenant';

  const getTenantInfo = async (
    competencyDate: string,
    competencyDateFinal?: string | null,
  ): Promise<ITenantInfoByCompetenceDate> => {
    const parameter =
      competencyDateFinal === null
        ? `competencyDate=${competencyDate}`
        : `competencyDate=${competencyDate}&competencyDateFinal=${competencyDateFinal}`;
    return await request
      .getOne({
        path: `${path}/info?${parameter}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const getTenant = async (): Promise<ITenant> => {
    return await tenantRequest
      .getOne({ path: `${path}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listValidationOptions = async (): Promise<IValidationOption[]> => {
    return await validationOptionRequest
      .getMany({ path: `${path}/validation-options`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const updateTenant = async (id: string, tenant: ITenant): Promise<ITenant> => {
    return await tenantRequest
      .put({ path: `${path}/${id}`, body: tenant, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { getTenantInfo, getTenant, updateTenant, listValidationOptions};
};

export { useTenantService };
